import styled from "@emotion/styled";
import colors from "/styles/colors";
export const StyledDirectoryTemplateComponent = styled.div`
  .directory-component-wrapper {
    background-color: #f5f5f5;
    padding-top: 80px;
  }

  nav.navbar {
    background-color: ${colors["white"]} !important;
  }
`;
